// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS } from 'immutable';
import { PICKUP_MODAL_ACTIONS_CONSTANTS } from '../PickUpStoreModal.constants';

const initialState = {
  isModalOpen: false, // TODO - Set ErrorBoundary in PICKUP Modal and .. Change it to default as false
  isBopisCtaEnabled: true,
  showUpdateStoreLoader: false,
  currentProduct: {},
  isBossCtaEnabled: true,
  isPickUpWarningModal: false,
  openSkuSelectionForm: false,
  generalProductId: null,
  colorProductId: null,
  requestorKey: null,
  initialValues: null,
  suggestedStores: null,
  cartStores: [],
  fromBagPage: false,
  fromChangeStore: false,
  updateCartItemStore: false,
  alwaysSearchForBOSS: false,
  openRestrictedModalForBopis: false,
  isSearching: false,
  isGetUserStoresLoaded: false,
  isSkuSelected: false,
  distance: null,
  isOpeningFromAvaialbilityFilter: false,
  storeIdList: null,
  showCartItemUpdateLoader: false,
};

const mergePickupModalState = (state, payload) => {
  // mergedPayload is used to make sure that default values of params are reset if not sent in payload
  const mergedPayload = {
    ...initialState,
    isModalOpen: true,
    colorProductId: payload.generalProductId,
    requestorKey: payload.generalProductId,
    ...payload,
  };
  return fromJS(mergedPayload);
};

/* eslint-disable complexity */
const PickupModalReducer = (state = fromJS(initialState), action) => {
  switch (action.type) {
    case PICKUP_MODAL_ACTIONS_CONSTANTS.PICKUP_MODAL_TOGGLE:
      return state.set('isModalOpen', action.payload.isModalOpen); // TODO - Make this one action - and use merge instead of set
    case PICKUP_MODAL_ACTIONS_CONSTANTS.PICKUP_MODAL_CLOSE:
      return state
        .merge(mergePickupModalState(state, action.payload))
        .set('pickupSelectedStore', action.payload.pickupSelectedStore)
        .set('isFromPickupButton', false)
        .set('fromEditModal', false)
        .set('newPartNumber', { multiPackData: null });
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_PICKUP_MODAL_PRODUCT:
      return state
        .set('currentProduct', action.payload.product)
        .set('initialSelectedQty', action.payload.setInitialTCPStyleQty)
        .set('isBopisPickup', action.payload.isBopisPickup || false);
    case PICKUP_MODAL_ACTIONS_CONSTANTS.PICKUP_MODAL_OPEN: {
      return state
        .merge(mergePickupModalState(state, action.payload))
        .set('currentProduct', action.payload.currentProduct)
        .set('initialSelectedQty', action.payload.initialSelectedQty)
        .set(
          'availableTCPMultipackProductMapping',
          action.payload.availableTCPMultipackProductMapping
        )
        .set('availableTCPmapNewStyleId', action.payload.availableTCPmapNewStyleId)
        .set('alternateBrand', action.payload.alternateBrand)
        .set('isBopisPickup', action.payload.isBopisPickup || false)
        .set('isBossPickupEdit', action.payload.isBossPickupEdit || false)
        .set('pickupSelectedStore', action.payload.pickupSelectedStore || {})
        .set('initialValuesOfProduct', action.payload.initialValues || {})
        .set('isPickUpSelected', action.payload.isPickUpSelected || '')
        .set('isFromPickupButton', action.payload.isFromPickupButton || false)
        .set('fromEditModal', action.payload?.fromEditModal)
        .set('newPartNumber', action.payload.newPartNumber);
    }
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_BOPIS_STORES:
      return state.set('suggestedStores', action.payload.stores);
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_USER_CART_STORES:
      return state.set('cartStores', action.payload.stores);
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_STORE_SEARCH_ERROR:
      return state.set('storeSearchError', action.payload);
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_RECOMMENDATION_NEAREST_AVAILABLE_STORE:
      return state.set('recommendationStores', action.payload);
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_STORE_SEARCH_STATE:
      return state.set('isSearching', action.payload);
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_IS_USER_CART_STORES_LOADED:
      return state.set('isGetUserStoresLoaded', action.payload);
    case PICKUP_MODAL_ACTIONS_CONSTANTS.RESET_ALTERNATE_BRAND:
      return state.set('alternateBrand', '');
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_PICKUP_SELECTED_STORE:
      return state.set('pickupSelectedStore', action.payload.pickupSelectedStore);
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_DEFAULT_STORE_LIST:
      return state.set('defaultNearByStoreList', action.payload.stores);
    case PICKUP_MODAL_ACTIONS_CONSTANTS.IS_SKU_EDIT: {
      return state.set('isSkuSelected', action.payload.isSkuSelected);
    }
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_DISTANCE_MILES: {
      return state.set('distance', action.payload.distance);
    }
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_NEAREST_AVAILABLE_STORE:
      return state.set('nearestAvailableStore', action.payload);
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_NEAREST_AVAILABLE_STORE_LOADING:
      return state.set('nearestAvailableStoreLoading', action.payload);
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_DEFAULT_SUGGESTED_STORES:
      return state.set('defaultSuggestStore', action.payload);
    case PICKUP_MODAL_ACTIONS_CONSTANTS.IS_FROM_AVAIALBILIY_FILTER: {
      return state.set(
        'isOpeningFromAvaialbilityFilter',
        action.payload.isOpeningFromAvaialbilityFilter
      );
    }
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_STOREID_LIST: {
      return state.set('storeIdList', action.payload);
    }
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_ALL_BOPIS_STORES: {
      return state.set('allBopisStores', action.payload);
    }
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_MULTIPRODUCT_DETAILS:
      return state.set('newPartNumber', action.payload);
    case PICKUP_MODAL_ACTIONS_CONSTANTS.PICKUP_UPDATE_STORE_LOADING:
      return state.set('showUpdateStoreLoader', action.payload);
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_UPDATE_CART_ITEM_LOADER:
      return state.set('showCartItemUpdateLoader', action.payload);
    case PICKUP_MODAL_ACTIONS_CONSTANTS.SET_STORE_SPECIAL_LIST: {
      return state.set('storeSpecialList', action.payload);
    }
    default:
      if (state instanceof Object) {
        return fromJS(state);
      }
      return state;
  }
};

export default PickupModalReducer;
